import React from "react";
import './../table.css';
import { groupAreasWithClinics } from "../utils";
export default (({ referralData = [] }) => {
    // const areaTableData = groupAreasWithClinics(referralData);
    return <>
        {
            referralData.map((item, index) => (
                <div key={`table_div_${index}`} className=" pdf-element" data-type="table">
                    {
                        index == 0 &&
                        <div>
                            <div className="mt-8">
                                <div className="d-flex justify-content-center">
                                    <div className="text-center bg-white px-4 py-2 rounded">
                                        <h3 className="header1">Practice-level & Source Split</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className={`mb-8`} >
                        <div className="d-flex justify-content-between w-full align-items-center">
                            <h5 className="heading3">
                                {item.areaName}
                            </h5>
                            <div>
                                <div className="badge" style={{
                                    background: '#D6F0FB 0% 0% no-repeat padding-box',
                                    boxShadow: '0px 1px 3px #0000000A',
                                    color: 'black', paddingTop: 7,
                                    height: 50, width: 100
                                }}>
                                    <h6>{item.totalClinics}</h6>
                                    <span>Total Patients</span>
                                </div>

                            </div>
                        </div>
                        <table className="table table-bordered mt-6 bg-white shadow table_border remove_strap">
                            <thead className="custom-header" >
                                <tr>
                                    <th>Practice</th>
                                    <th>Programme</th>
                                    <th>Total</th>
                                    <th>Total Onboarderd</th>
                                    <th>SMS</th>
                                    <th>WhatsApp</th>
                                    <th>Other</th>
                                </tr>
                            </thead>
                            <tbody>
                                {item.clinics.map((group, index_1) => (
                                    <React.Fragment key={`frag_n_${index_1}`}>
                                        {group.programs.map((program, i) => (
                                            <tr key={`key_d_${i}`}>
                                                {i === 0 && (
                                                    <td rowSpan={group.programs.length}
                                                        className="tdRowspan">
                                                        <p> {group.clinicName}</p>
                                                        <div className="rowspan">
                                                            {group.clinicName}
                                                        </div>
                                                    </td>
                                                )}
                                                <td>{program.programName}</td>
                                                <td>{program.count}</td>
                                                <td>{program.onboard}</td>
                                                <td>{program?.sms || 0}</td>
                                                <td>{program?.whatsapp || 0}</td>
                                                <td>{program?.other || 0}</td>
                                            </tr>
                                        ))}

                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))
        }

    </>
});